angular.module('bb.assets').factory('AssetsService', AssetsService);

AssetsService.$inject = ['$resource'];
function AssetsService($resource) {
  const MetaData = $resource('/metadata');
  const AssetFileUpload = $resource('/asset/file/:fileId', {
    fileId: '@fileId',
  });

  const DeleteAssetFolder = $resource('/asset/folder/:folderId', {
    folderId: '@folderId',
  });

  const AssetFolder = $resource('/asset/folder', {
    page: '@page',
    limit: '@limit',
    isAdmin: '@isAdmin',
    folderId: '@folderId',
  });

  const AssetFolderById = $resource('/asset/folder/:folderId', {
    folderId: '@folderId',
  });

  const AssetFile = $resource('/asset/file/:folderId/:fileId', {
    fileId: '@fileId',
    page: '@page',
    limit: '@limit',
    folderId: '@folderId',
  });
  const FilesSearch = $resource('/search/files');

  function getVideoMeta(link) {
    return MetaData.get({ verb: 'video', link }).$promise;
  }

  function assetFileUpload(files, folderId) {
    const fileUpload = new AssetFileUpload({ files });
    if (folderId) fileUpload.folder = folderId;
    return fileUpload.$save();
  }

  function updateAssetFile(fileId, fileName) {
    return AssetFileUpload.save({ fileId, fileName }).$promise;
  }

  function saveFolder(folder) {
    return AssetFolder.save(folder).$promise;
  }

  function getFolderById(folderId) {
    return AssetFolderById.get({ folderId }).$promise;
  }

  function getFolders(page, limit, isAdmin, folderId) {
    return AssetFolder.get({ page, limit, isAdmin, folderId }).$promise;
  }
  function deleteFolder(folderId) {
    return DeleteAssetFolder.delete({ folderId }).$promise;
  }

  function getFiles(folderId, page, limit) {
    return AssetFile.get({ page, limit, folderId }).$promise;
  }
  function deleteFile(fileId) {
    return AssetFile.delete({ fileId }).$promise;
  }

  function searchFiles(input) {
    return FilesSearch.query({ input }).$promise;
  }

  // Helpers
  const determineCssClass = mimeType => {
    // List of official MIME Types: http://www.iana.org/assignments/media-types/media-types.xhtml
    const ICON_CLASSES = {
      folder: 'fa-folder',
      image: 'fa-file-image-o',
      audio: 'fa-file-audio-o',
      video: 'fa-file-video-o',
      'application/pdf': 'fa-file-pdf-o',
      'application/msword': 'fa-file-word-o',
      'application/vnd.ms-word': 'application/vnd.oasis.opendocument.text',
      'application/vnd.oasis.opendocument.text': 'fa-file-word-o',
      'application/vnd.openxmlformats-officedocument.wordprocessingml':
        'fa-file-word-o',
      'application/vnd.ms-excel': 'fa-file-excel-o',
      'application/vnd.openxmlformats-officedocument.spreadsheetml':
        'fa-file-excel-o',
      'application/vnd.oasis.opendocument.spreadsheet': 'fa-file-excel-o',
      'application/vnd.ms-powerpoint': 'fa-file-image-o',
      'application/vnd.openxmlformats-officedocument.presentationml':
        'fa-file-powerpoint-o',
      'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint-o',
      'text/plain': 'fa-file-text-o',
      'text/html': 'fa-file-code-o',
      'application/json': 'fa-file-code-o',
      'application/zip': 'fa-file-archive-o',
      'application/gzip': 'fa-file-archive-o',
      'application/x-shockwave-flash': 'fa-youtube-play',
    };
    let iconClass;
    Object.keys(ICON_CLASSES).forEach(iconType => {
      if (mimeType.includes(iconType)) {
        iconClass = ICON_CLASSES[iconType];
      }
    });
    return iconClass || 'fa-file-o';
  };

  return {
    getVideoMeta,
    assetFileUpload,
    updateAssetFile,
    saveFolder,
    getFolderById,
    getFolders,
    deleteFolder,
    getFiles,
    deleteFile,
    searchFiles,
    // Helpers
    determineCssClass,
  };
}

export {};
